import {
  AUTH_REGION,
  AUTH_USER_POOL_ID,
  AUTH_USER_POOL_WEB_CLIENT_ID,
  AUTH_COOKIE_DOMAIN,
  AUTH_REDIRECT_SIGN_IN,
  AUTH_REDIRECT_SIGN_OUT,
  // AUTH_USER_POOL_SECRET,
  REACT_APP_AUTH_DOMAIN_NAME
} from './configs';


export const AwsConfigAuth = {
  Auth: {
    region: AUTH_REGION,
    userPoolId: AUTH_USER_POOL_ID,
    userPoolWebClientId: AUTH_USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: REACT_APP_AUTH_DOMAIN_NAME,
      scope: [
        "aws.cognito.signin.user.admin",
        "email",
        "openid",
        "phone",
        "profile",
      ],
      redirectSignIn: AUTH_REDIRECT_SIGN_IN,
      redirectSignOut: AUTH_REDIRECT_SIGN_OUT,
      responseType: "token",
    },
  }
};